import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import core from '@gin-betting/core';
import favorite from '@gin-betting/favorite';
import { createStructuredSelector } from 'reselect';

import { ToggleFavoriteButton } from 'components';
import { useMemoSelector } from 'hooks';

interface Props {
    matchId: string;
}
const {
    utils: { getBettingOptions },
} = core;

const {
    actions: {
        addMatchToFavoriteRequest,
        addMatchToFavoriteLocal,
        deleteMatchFromFavoriteRequest,
        deleteMatchFromFavoriteLocal,
    },
    selectors: { selectIsFavoriteSportEvent },
} = favorite;

const ToggleFavoriteButtonContainer: React.FC<Props> = ({ matchId }) => {
    const dispatch = useDispatch();

    const { isActive } = useMemoSelector(makeSelectProps(), { matchId }, [
        matchId,
    ]);

    const handleAddFavorite = useCallback(
        (favoriteId: string) => {
            const { isAuthorized } = getBettingOptions();

            if (isAuthorized) {
                dispatch(addMatchToFavoriteRequest({ favoriteId }));
            } else {
                dispatch(addMatchToFavoriteLocal({ favoriteId }));
            }
        },
        [dispatch]
    );

    const handleDeleteFavorite = useCallback(
        (favoriteId: string) => {
            const { isAuthorized } = getBettingOptions();

            if (isAuthorized) {
                dispatch(deleteMatchFromFavoriteRequest({ favoriteId }));
            } else {
                dispatch(deleteMatchFromFavoriteLocal({ favoriteId }));
            }
        },
        [dispatch]
    );

    const toggleFavorite = useCallback(() => {
        if (isActive) {
            handleDeleteFavorite(matchId);
        } else {
            handleAddFavorite(matchId);
        }
    }, [isActive, handleDeleteFavorite, handleAddFavorite, matchId]);

    return React.createElement(ToggleFavoriteButton, {
        isActive,
        toggle: toggleFavorite,
    });
};

const makeSelectProps = () =>
    createStructuredSelector({
        isActive: selectIsFavoriteSportEvent,
    });

export default ToggleFavoriteButtonContainer;
